import React, { useState, useEffect } from 'react'
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import Search from "../../components/ThirdPartyDashboard/Search";
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { facilityVerify } from "../../apis/General/web3/shared";
import { useSelector } from 'react-redux';
import { getThreeMonthUnverifiedAccumulationsForPlant, getThreeMonthUnverifiedAccumulationsAll } from "../../instantiateTransaction/basicGreenProject";
import { toast } from 'react-toastify';
import { getUserInfo } from '../../apis/General/users';

function GetVerificationKyc() {
    const { id } = useParams();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const auth = useSelector((state) => state.auth);

    const userId = "UN9ujbCjkMHfmgKWhM38maR4";

    const fetchUserInfo = async () => {
      try {
        setLoading(true);
        const response = await getUserInfo(userId, auth?.token);
        console.log("getUser:", response);
        setUserData(response?.data?.message);
      } catch (error) {
        console.error("Error fetching user info:", error.response?.data || error.message);
        toast.error('Failed to fetch user information');
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchUserInfo();
    }, []);

    if (loading) {
      return (
        <div className="thirdparty_verification">
          <div className="sidebar_container">  
            <SideBar />
          </div>
          <div className="main">
            <Search />
            <div className="flex justify-center items-center h-screen">
              <div className="text-lg">Loading user data...</div>
            </div>
          </div>
        </div>
      );
    }

    return (
        <div className="thirdparty_verification">
            <div className="sidebar_container">  
                <SideBar />
            </div>

            <div className="main">
                <Search />
                
                {/* Main Content Container */}
                <div className="absolute w-[1178px] h-[1872px] left-[250px] top-[78px]  mt-20 rounded-[24px]">
                    
                    {/* Back Button */}
                    <Link 
                        to="/verification" 
                        className="absolute flex flex-row items-center gap-[2px] left-[32px] top-[32px] w-[55px] h-[24px] cursor-pointer"
                    >
                        {/* Back Arrow */}
                        <div className="w-[24px] h-[24px] relative">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.5824 6.59244H3.41244L8.29244 1.71244C8.68244 1.32244 8.68244 0.682444 8.29244 0.292444C8.19993 0.19974 8.09004 0.126193 7.96907 0.0760112C7.8481 0.0258297 7.71841 0 7.58744 0C7.45648 0 7.32679 0.0258297 7.20582 0.0760112C7.08485 0.126193 6.97496 0.19974 6.88244 0.292444L0.292444 6.88244C0.199741 6.97496 0.126193 7.08485 0.0760117 7.20582C0.0258302 7.32679 0 7.45648 0 7.58744C0 7.71841 0.0258302 7.84809 0.0760117 7.96907C0.126193 8.09004 0.199741 8.19993 0.292444 8.29244L6.88244 14.8824C6.97503 14.975 7.08494 15.0485 7.2059 15.0986C7.32687 15.1487 7.45651 15.1745 7.58744 15.1745C7.71837 15.1745 7.84802 15.1487 7.96899 15.0986C8.08995 15.0485 8.19986 14.975 8.29244 14.8824C8.38503 14.7899 8.45847 14.68 8.50857 14.559C8.55868 14.438 8.58447 14.3084 8.58447 14.1774C8.58447 14.0465 8.55868 13.9169 8.50857 13.7959C8.45847 13.6749 8.38503 13.565 8.29244 13.4724L3.41244 8.59244H14.5824C15.1324 8.59244 15.5824 8.14244 15.5824 7.59244C15.5824 7.04244 15.1324 6.59244 14.5824 6.59244Z" fill="black"/>
                            </svg>
                        </div>
                        {/* Back Text */}
                        <span className="w-[29px] h-[15px] font-inter font-medium text-[12px] leading-[15px] text-[#2C2C2C]">
                            Back
                        </span>
                    </Link>

                    {/* Main Form Container */}
                    <div className="absolute flex flex-col items-end gap-[32px] left-[32px] top-[80px] w-[1080px] h-[1760px]">
                        <div className="flex flex-col items-start gap-[32px] w-full h-full">
                          
                            {/* First Name */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    First name
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.firstName || 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Last Name */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Last name
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.lastName || 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Email
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.email || 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Company Name */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Company Name
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.companyName || 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Facility Name */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility name
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.companyName || 'N/A'} {/* Using company name as facility name */}
                                    </div>
                                </div>
                            </div>

                            {/* Facility Description */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[112px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility description
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[112px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.companyName ? `${userData.companyName} focuses on energy generation and sustainability solutions.` : 'No description available'}
                                    </div>
                                </div>
                            </div>

                            {/* Facility Category */}
                            <div className="flex flex-row items-center gap-[30px] w-full h-[64px]">
                                <label className="w-[235px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility category
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        Non-green
                                    </div>
                                </div>
                            </div>

                            {/* Sustainability Solution */}
                            <div className="flex flex-row items-center gap-[30px] w-full h-[64px]">
                                <label className="w-[235px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Sustainability solution
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        Infrastructure change
                                    </div>
                                </div>
                            </div>

                            {/* Facility Capacity */}
                            <div className="flex flex-row items-center gap-[30px] w-full h-[64px]">
                                <label className="w-[235px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility capacity
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        500Kw/Hr
                                    </div>
                                </div>
                            </div>

                            {/* Facility Location */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility location
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.address ? `${userData.address}, ${userData.country}` : 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Facility Start Date */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[64px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility start date
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.createdAt ? new Date(parseInt(userData.createdAt)).toLocaleDateString() : 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Facility Fuel Source */}
                            <div className="flex flex-row items-center gap-[81px] w-full h-[64px]">
                                <label className="w-[182px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Facility fuel source
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[817px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        Coal
                                    </div>
                                </div>
                            </div>

                            {/* Additional Information */}
                            <div className="flex flex-row items-center gap-[44px] w-full h-[112px]">
                                <label className="w-[221px] h-[42px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Additional information relevant to the project
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[112px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.companyName ? `${userData.companyName} focuses on fossil fuel extraction, production, and energy generation, with comprehensive sustainability initiatives.` : 'No additional information available.'}
                                    </div>
                                </div>
                            </div>

                            {/* Double Counting */}
                            <div className="flex flex-row items-center gap-[30px] w-full h-[64px]">
                                <label className="w-[235px] h-[42px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Double counting and participation under other GHG programs
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        NO
                                    </div>
                                </div>
                            </div>

                            {/* Baseline Scenario */}
                            <div className="flex flex-row items-center gap-[82px] w-full h-[112px]">
                                <label className="w-[183px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Baseline scenario
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[112px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        {userData?.companyName ? `${userData.companyName} baseline scenario involves traditional energy production methods with planned transition to sustainable solutions.` : 'No baseline scenario defined.'}
                                    </div>
                                </div>
                            </div>

                            {/* Fuel Source in Baseline Scenario */}
                            <div className="flex flex-row items-center gap-[30px] w-full h-[64px]">
                                <label className="w-[235px] h-[21px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Fuel source in baseline scenario
                                </label>
                                <div className="flex flex-row justify-center items-center p-[20px_24px] gap-[10px] w-[815px] h-[64px] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="w-full h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828] bg-transparent">
                                        Petrol
                                    </div>
                                </div>
                            </div>

                            {/* Proof of Fuel Source */}
                            <div className="flex flex-row items-center gap-[30px] w-full h-[80px]">
                                <label className="w-[235px] h-[42px] font-inter font-normal text-[14px] leading-[21px] text-[#101828]">
                                    Proof of fuel source in baseline scenario
                                </label>
                                <div className="flex flex-row items-center p-[20px_24px] gap-[10px] w-[815px] h-[80px] bg-[#F9FAFB] border-[0.5px] border-[#667185] rounded-[8px] flex-grow">
                                    <div className="flex flex-row justify-between items-center w-[767px] h-[40px]">
                                        <div className="flex flex-row items-center gap-[4px] w-[247px] h-[24px] mx-auto">
                                            {/* Document Icon */}
                                            <div className="w-[24px] h-[24px] relative">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 4.5L11.5 2H4C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V4.5Z" stroke="#038B47" strokeWidth="1.5" fill="none"/>
                                                    <path d="M11.5 2V4.5H14" stroke="#038B47" strokeWidth="1.5" fill="none"/>
                                                </svg>
                                            </div>
                                            {/* no document place holder  */}
                                            <span className="w-[219px] h-[24px] font-inter font-normal text-[16px] leading-[24px] text-[#101828]">
                                                {userData?.companyName ? `${userData.companyName} Baseline proof` : 'Baseline proof document'}
                                            </span>
                                        </div>
                                        <button className="flex flex-row justify-center items-center p-[8px] gap-[12px] w-[139px] h-[40px] rounded-[12px] mx-auto">
                                            <span className="w-[123px] h-[24px] font-inter font-semibold text-[16px] leading-[24px] text-center underline text-[#038B47]">
                                                View Document
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetVerificationKyc;